import { render, staticRenderFns } from "./CommercialLaw.vue?vue&type=template&id=7257a80e&"
import script from "./CommercialLaw.vue?vue&type=script&lang=js&"
export * from "./CommercialLaw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports